import { OnboardingStatus } from './enums'

export const ONBOARDING_STATUSES_WITH_DELAYED_INFO = [
  OnboardingStatus.Created,
  OnboardingStatus.WaitingForApproval,
  OnboardingStatus.Failed,
  OnboardingStatus.PartiallyCompleted,
]

export const onboardingStatusTitle = {
  [OnboardingStatus.Created]: 'Invited contractors',
  [OnboardingStatus.WaitingForApproval]: 'Waiting for approval',
  [OnboardingStatus.Completed]: 'Onboarded contractors',
  [OnboardingStatus.Failed]: 'Onboarding failed',
  [OnboardingStatus.PartiallyCompleted]: 'Partially Completed',
}
